import { api } from '@/shared/lib/api'

/**
 * Registra no servidor até onde o participante já viu seus ganhos.
 *
 * Envia o maior id efetivamente exibido — nunca "marque tudo como visto" — para
 * que um movimento criado entre a leitura e o ACK não seja dado por visto sem
 * nunca ter aparecido.
 */
export const ackRewardGain = async ({
  digitalProductId,
  lastMovementId
}: {
  digitalProductId: string | number
  lastMovementId: number
}): Promise<void> => {
  await api.patch(
    `/user/digital_products/${digitalProductId}/wallet/seen`,
    { record: { last_movement_id: lastMovementId } }
  )
}
